// Centralized taxonomy URL builder — the SINGLE source of truth for every
// category/subcategory link in the app. No component may build category URLs
// from UUIDs or live names; they must call these helpers (or use node.url_path
// returned by the backend, which these mirror).
//
// Category URLs use the RAW listing_type ('service', not 'services') to match
// the backend's materialized url_path. The type BROWSE pages use TYPE_PATH.

const TYPE_PATH = { sell: 'sell', wanted: 'wanted', rent: 'rent', service: 'services' };

export function typeBrowsePath(type) {
  return '/' + (TYPE_PATH[type] || type || 'sell');
}

// Build a canonical category/subcategory path from stable path_slugs.
export function categoryUrl(type, catPathSlug, subPathSlug) {
  if (!type || !catPathSlug) return null;
  const parts = ['/category', type, catPathSlug];
  if (subPathSlug) parts.push(subPathSlug);
  return parts.join('/');
}

// Canonical URL for a category node object (from /categories or /categories/tree).
export function nodeUrl(node) {
  if (!node) return null;
  if (node.url_path) return node.url_path;
  return categoryUrl(node.listing_type, node.path_slug || node.slug);
}

// Canonical category URL derived from a LISTING (for breadcrumbs / related).
export function listingCategoryUrl(listing, { includeSub = false } = {}) {
  if (!listing) return null;
  const cat = listing.category_path_slug || listing.category_slug;
  const sub = includeSub ? (listing.subcategory_path_slug || listing.subcategory_slug) : null;
  return categoryUrl(listing.listing_type, cat, sub);
}

export default nodeUrl;
